const ossApi = '/ossApi'
let hostname = window.location.hostname
const encryptionJS = require('../../assets/js/encryption');
// 社工
let areaCode = '11'
let tenantCode = '110000000000000001'
let title = ''
let imageUrl = ''
let username = ''
let password = ''
let serviceUrl = ''  //履职服务平台
let systemType = 'other'
// 百色
if (hostname === 'www.bsswshgzb.gov.cn' || hostname === 'bsswshgzb.gov.cn') {
  tenantCode = '451000000000000001'
  areaCode = '4510'
  title = '百色市社会工作部'
  imageUrl = ossApi + '/szsg_bss'
  username = encryptionJS.aesDecrypt('ZgAE4dZsbhJlTq9OHnnJDQ==')
  password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
  serviceUrl = 'https://szsg.hjshgzb.gov.cn'
}
switch (process.env.NODE_ENV) {
  case 'development': // 开发环境
    tenantCode = '451000000000000001'
    areaCode = '4510'
    title = '百色市社会工作部'
    imageUrl = ossApi + '/szsg_bss'
    username = encryptionJS.aesDecrypt('ZgAE4dZsbhJlTq9OHnnJDQ==')
    password = encryptionJS.aesDecrypt('65DQ19IWzgEgSSfwqVNXrQ==')
    serviceUrl = 'https://szsg.hjshgzb.gov.cn'
    break
  default:
    break
}
export default {
  ossApi,
  tenantCode,
  title,
  imageUrl,
  username,
  password,
  areaCode,
  systemType
}
